import { render } from "./DivorceView.vue?vue&type=template&id=2a8cd27f"
import script from "./DivorceView.vue?vue&type=script&lang=js"
export * from "./DivorceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__